import {
  parseSearchNumberValue,
  parseSearchStringValue,
  parseSearchArrayValue,
} from 'infrastructure/functions/parse-query-string';
import { useQueryFilterNew } from 'infrastructure/hooks/common/use-query-param-new';

import type { TParseFunctions } from 'infrastructure/hooks/common/use-query-param-new';
import type { Filters } from './types';

const DEFAULT_FILTERS: Filters = {
  page: 1,
  items: 100,
  billingMonth: new Date().getMonth() + 1,
  billingYear: new Date().getFullYear(),
  patientKey: 'fullName',
};

const parseFunctions: TParseFunctions<Filters> = {
  page: parseSearchNumberValue,
  items: parseSearchNumberValue,
  billingYear: parseSearchNumberValue,
  billingMonth: parseSearchNumberValue,
  patientGuid: parseSearchStringValue,
  clinicGuid: parseSearchStringValue,
  doctorGuid: parseSearchStringValue,
  agencyGuid: parseSearchStringValue,
  agencyDoctorGuid: parseSearchStringValue,
  actionTypes: parseSearchArrayValue,
  patientKey: parseSearchStringValue,
  patientLabel: parseSearchStringValue,
  source: parseSearchStringValue,
};

export const useActionTimeManagementFilters = () => {
  return useQueryFilterNew<Filters>(DEFAULT_FILTERS, parseFunctions, [
    'page',
    'patientLabel',
    'patientKey',
  ]);
};
